import { Component, OnInit, Input } from '@angular/core';

import { HeaderMenuService } from '../header-menu.service';
import { MenuItem } from '../models/menu-item.model';

@Component({
  selector: 'header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.css']
})
export class HeaderMenuComponent implements OnInit {
    @Input() items: MenuItem[];

    constructor(private service: HeaderMenuService) { }

    ngOnInit() {
        this.service.get().subscribe(res => this.items = res);
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/header-menu/header-menu.component.ts